import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskListGroupReducer(
	state = initialState.isTaskListGroup,
	action
) {
	switch (action.type) {
		case types.GET_IS_TASKS_GROUP: {
			return action.response;
		}
		case types.SET_IS_TASKS_GROUP: {
			return action.isTaskListGroup;
		}
		
		case types.TASK_LIST_LOADED: {
			let taskGroups = action.taskGroups;
			let isTaskGroup = !(
				taskGroups &&
				taskGroups.length === 1 &&
				taskGroups[0].id === null
			);
			return isTaskGroup;
		}
		default:
			return state;
	}
}
